import { Typography } from "@material-ui/core";
import * as React from "react";
import { withTranslation } from "react-i18next";
import { compose, pure, setDisplayName } from "recompose";
import { AppStoreLinks, Dialog } from "components";
import logoSvg from "assets/logo_eqwin.svg";
import qrCodeSvg from "assets/qr_code.svg";
export var Render = function (_a) {
    var t = _a.t;
    return (React.createElement(Dialog, null,
        React.createElement("div", { style: { textAlign: "center", padding: "16px 0" } },
            React.createElement("img", { src: logoSvg, alt: window.env.COGNITO_IDENTITY_POOL_NAME, style: { maxWidth: 200, marginBottom: 24 } }),
            React.createElement(Typography, { style: {
                    color: "#76686A",
                    fontFamily: "Area Normal, sans-serif",
                    fontSize: 13,
                    marginBottom: 24,
                } }, t("download_cta")),
            React.createElement("img", { src: qrCodeSvg, alt: t("download_qr_alt"), style: { display: "block", margin: "24px auto 0", width: 160 } }),
            React.createElement(AppStoreLinks, null))));
};
export function enhance() {
    return compose(withTranslation(), pure, setDisplayName("Download"));
}
export var Download = enhance()(Render);
